import { useMyOrganization } from './useMyOrganization'

/**
 * Whether the signed-in person sees «Tilbakemelding», and for which organisation.
 *
 * The switch is per person per organisation (`organization_members.feedback_enabled`,
 * set by EventRipple, never by the customer). It follows the ACTIVE organisation, the
 * one the shell says you are working as, so feedback is always filed for the customer
 * whose data is on the screen.
 */
export function useCustomerFeedback(): { enabled: boolean; orgId: string | null; orgName: string | null } {
  const { active } = useMyOrganization()
  const enabled = active?.feedback_enabled === true
  return { enabled, orgId: enabled ? active!.org.id : null, orgName: enabled ? active!.org.name : null }
}
